import React, { FC } from 'react';
import { ViewSwitcher } from 'components/organisms/tasks/view-switcher';
import { RoutePaths } from 'constant';

export const AllTasksViewSwitcher: FC = () => {
  return (
    <ViewSwitcher listUrl={RoutePaths.tasks} boardUrl={RoutePaths.tasksBoard} />
  );
};
